export default "__VITE_ASSET__DN5$4TAq__"